module.exports = __webpack_public_path__ + "img/39.d077b702.jpg";